import { render } from "./MainCalculator.vue?vue&type=template&id=3becb684"
import script from "./MainCalculator.vue?vue&type=script&lang=js"
export * from "./MainCalculator.vue?vue&type=script&lang=js"

import "./MainCalculator.vue?vue&type=style&index=0&id=3becb684&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__